export default __webpack_public_path__ + "static/nadya-cf5a628e9e87dbbde275ff4f08f84f60.png";